import React from "react";
import { useTranslation } from "react-i18next";
import { useUpdateFolder } from "@planzone/view-models";

import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { TextInput } from "@common/textInput";
import { Props } from "./types";
import styles from "./styles.scss";

function FolderUpdate({ folder, type, namespace, close }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, updateFolder } = useUpdateFolder();
  const [name, setName] = React.useState(folder.name);

  return (
    <Modal header={t("folderUpdate.title")} close={close}>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          !isRequestPending &&
            updateFolder({
              folder: {
                ...folder,
                name,
              },
              type,
              namespace,
            });
        }}
        className={styles.updateFolder}
      >
        <div className={styles.main}>
          <TextInput
            placeholder={t("folderUpdate.placeholder")}
            value={name}
            input={setName}
          />
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={close}>
            {t("folderUpdate.cancel")}
          </Button>
          <Button status={isRequestPending ? "pending" : "none"} type="submit">
            {t("folderUpdate.submit")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { FolderUpdate };
